<h1 ev-dialog-title>
  <span [innerHtml]="accountDialogTitles()[activeStepIndex()]">{{
    languageService.languageJSON.AccountDialog_Title_Account }}</span>
</h1>

<div ev-dialog-content #accountScrollbar class="scrollable" data-testid="account-container">
  <div class="account-content">

    @if (activeStepIndex()==0) {
    <app-account-sign-in-step [formGroup]="firstStepFormGroup" [firstStepError]="firstStepError()"
      [preiOS13WebView]="preiOS13WebView()" [androidWebView]="androidWebView()" (signIn)="signIn()"
      (register)="nextStep()" (forgotPassword)="openForgotPassword()">
    </app-account-sign-in-step>
    }

    @if (activeStepIndex()==1) {
    <app-account-register-credentials-step [formGroup]="secondStepFormGroup" [existingEmailMsg]="existingEmailMsg()"
      [preiOS13WebView]="preiOS13WebView()" [androidWebView]="androidWebView()"
      (openPrivacyPolicy)="openPrivacyPolicy()" (openTermsOfUse)="openTermsOfUse()"
      (openEUDataActPolicy)="openEUDataActPolicy()">
    </app-account-register-credentials-step>
    }

    @if (activeStepIndex()==2 || activeStepIndex()==5) {
    <app-account-profile-step #profileStep [formGroup]="thirdStepFormGroup" [isEditMode]="activeStepIndex()==5"
      [countryList]="countryList()" [backendErrorMsg]="backendErrorMsg()"
      (avatarProcessing)="onAvatarProcessing($event)" (changePassword)="nextStep()" (deleteProfile)="deleteProfile()"
      (downloadUserData)="downloadUserData()">
    </app-account-profile-step>
    }

    @if (registerLoader()) {
    <div class="dialog-loader-outer">
      <app-ev-loader></app-ev-loader>
    </div>
    }

    @if (activeStepIndex()==3) {
    <app-account-verification-pending-step [emailSent]="emailSent()" (resendEmail)="resendEmail()">
    </app-account-verification-pending-step>
    }

    @if (activeStepIndex()==4) {
    <app-account-verification-result-step [verifyFailed]="verifyFailed()">
    </app-account-verification-result-step>
    }

    @if (activeStepIndex()==6) {
    <app-account-change-password-step [formGroup]="sixthStepFormGroup" [invalidActualPassword]="invalidActualPassword()"
      [passwordChangeSuccess]="passwordChangeSuccess()">
    </app-account-change-password-step>
    }

    @if (activeStepIndex()==7) {
    <app-account-forgot-password-step [formGroup]="seventhStepFormGroup" [existingEmailMsg]="existingEmailMsg()"
      [emailSent]="emailSent()">
    </app-account-forgot-password-step>
    }

    @if (registerError()) {
    <div class="input-el error-bottom" [ngClass]="{'error-bottom-margin': activeStepIndex()!== 1 }">
      <h5 class="error-text">{{ languageService.languageJSON.Global_SomethingWentWrong }}</h5>
    </div>
    }
  </div>
</div>

<div ev-dialog-actions [hidden]="activeStepIndex()!=0 && activeStepIndex()!=3 && activeStepIndex()!=4">
  @if (activeStepIndex()!=0) {
  <button class="ev-button primary" name="exit_button" mat-button (click)="close()" data-testid="account-ok-btn">
    {{ languageService.languageJSON.Global_Ok }}
  </button>
  }
  @if (activeStepIndex()==0) {
  <button class="ev-button" name="exit_button" mat-button (click)="close()" data-testid="account-cancel-btn">
    {{ languageService.languageJSON.Global_Cancel }}
  </button>
  }
</div>

<div ev-dialog-actions [hidden]="activeStepIndex()!=1 && activeStepIndex()!=2">
  <button class="ev-button" name="back_button" mat-button (click)="goBack()" data-testid="account-back-btn">{{
    languageService.languageJSON.Global_Back }}</button>
  <button class="ev-button primary" name="next_button" mat-button (click)="nextStep()" data-testid="account-next-btn">{{
    languageService.languageJSON.Global_Next }}</button>
</div>

<div ev-dialog-actions [hidden]="activeStepIndex()!=5">
  <button class="ev-button primary" name="exit_button" mat-button (click)="saveProfile()"
    data-testid="account-save-btn">{{
    languageService.languageJSON.Global_Save }}</button>
  <button class="ev-button" name="exit_button" mat-button (click)="close()" data-testid="account-edit-cancel-btn">{{
    languageService.languageJSON.Global_Cancel }}</button>
</div>

<div ev-dialog-actions [hidden]="activeStepIndex()!=6">
  @if (!passwordChangeSuccess()) {
  <button class="ev-button primary" name="exit_button" mat-button (click)="changePassword()"
    data-testid="account-change-password-btn">{{
    languageService.languageJSON.Global_Change }}</button>
  <button class="ev-button" name="exit_button" mat-button (click)="goBack()" data-testid="account-change-cancel-btn">{{
    languageService.languageJSON.Global_Cancel }}</button>
  }
  @if (passwordChangeSuccess()) {
  <button class="ev-button primary" name="exit_button" mat-button (click)="close()"
    data-testid="account-change-ok-btn">{{
    languageService.languageJSON.Global_Ok }}</button>
  }
</div>

<div ev-dialog-actions [hidden]="activeStepIndex()!=7">
  @if (!emailSent()) {
  <button class="ev-button primary" name="exit_button" mat-button (click)="recoverPassword()"
    data-testid="account-recover-send-btn">{{
    languageService.languageJSON.Global_Send }}</button>
  <button class="ev-button" name="exit_button" mat-button (click)="goBackToLogin()"
    data-testid="account-recover-back-btn">{{
    languageService.languageJSON.Global_Back }}</button>
  }
  @if (emailSent()) {
  <button class="ev-button primary" name="exit_button" mat-button (click)="goBackToLogin()"
    data-testid="account-recover-ok-btn">
    {{ languageService.languageJSON.Global_Ok }}
  </button>
  }
</div>